import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import type { Reducer, Store } from 'redux';
import type { Middleware } from '@reduxjs/toolkit';
import { configureStore } from '@reduxjs/toolkit';

import { RequestErrorModal } from 'js/src/components/common/RequestErrorModal';
import { Toast } from 'js/src/components/common/Toast';
import { createReduxEnhancer } from 'js/src/libs/sentry';

let reduxDevTools = false;
///////////
/////////////////////
//////////

export function createReduxStore(
    rootReducer: Reducer,
    preloadedState?: any,
    extraMiddleware?: Middleware[],
) {
    const store = configureStore({
        reducer: rootReducer,
        preloadedState,
        middleware: (getDefaultMiddleware) => {
            const mw = getDefaultMiddleware({
                thunk: {
                    extraArgument: {},
                },
                immutableCheck: false,
                serializableCheck: false,
            });
            return extraMiddleware ? mw.concat(...extraMiddleware) : mw;
        },
        devTools: reduxDevTools,
        enhancers: (getDefaultEnhancers) => getDefaultEnhancers().concat(createReduxEnhancer()),
    });

///////////////
//////////////////////////
//////////////

    return store;
}

export function renderWithRedux(Component: React.ComponentType, store: Store) {
    const container = document.getElementById('react-root');
    if (!container) {
        throw new Error('Could not find #react-root element');
    }
    const root = createRoot(container);
    root.render(
        <Provider store={store}>
            <Component />
            <Toast.Component />
            <RequestErrorModal />
        </Provider>,
    );
}

export function renderComponent(Component: React.ComponentType) {
    const container = document.getElementById('react-root');
    if (!container) {
        throw new Error('Could not find #react-root element');
    }
    const root = createRoot(container);
    root.render(
        <>
            <Component />
            <Toast.Component />
            <RequestErrorModal />
        </>,
    );
}
